__turbopack_context__.v({
  "externalIcon": "Link-module__U5i1fW__externalIcon",
  "link": "Link-module__U5i1fW__link",
  "linkInherit": "Link-module__U5i1fW__linkInherit",
  "linkLg": "Link-module__U5i1fW__linkLg",
  "linkMd": "Link-module__U5i1fW__linkMd",
  "linkSm": "Link-module__U5i1fW__linkSm",
  "underlineHover": "Link-module__U5i1fW__underlineHover",
});
